
import Vue from 'vue';
import getItemFromObject from 'lodash/get';
import { DataWithHref } from '@root/modules/headlines/types/headlines';
import { HeadlineLabels, HeadlineTitle, HeadlineImage, HeadlineLead } from '@headlines/components/fragments';

interface Data {
  leadLimit: number;
}

interface Props {
  headline: DataWithHref;
  pictureSrcset: Record<string, unknown>;
  template: string;
}

interface Computed {
  ptContent: boolean;
}

interface Methods {
  labels: (headline: DataWithHref) => (string | undefined)[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    HeadlineLabels,
    HeadlineImage,
    HeadlineTitle,
    HeadlineLead,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
    pictureSrcset: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    template: {
      type: String,
      required: false,
      default: () => 'horizontal',
    },
  },
  data() {
    return {
      leadLimit: 140,
    };
  },
  computed: {
    ptContent() {
      return !!(this.headline.settings && this.headline.settings.find((setting) => setting.key === 'icon.reklama')?.value);
    },
  },
  methods: {
    labels(headline) {
      const labels = [];

      const { domain } = this.$channelConfig('settings');
      const sameChannel = domain === headline.primaryCategory.channel.url;

      if (!sameChannel && headline.primaryCategory.channel.url !== 'www.delfi.lt') {
        labels.push(getItemFromObject(headline, 'primaryCategory.channel.name'));
      } else {
        labels.push(getItemFromObject(headline, 'primaryCategory.name'));
      }

      return labels;
    },
  },
});
